import { ScreenSequence } from "../Sequences";
import { PosttestScreen1 } from "./PosttestScreen1";

export const PosttestKey = "Posttest";

export const PosttestSequence: ScreenSequence = {
    name: "Verhaltensökonomische Kompetenzen – Was hast du gelernt?",
    description: "In diesem Fragebogen geht es darum, was du während des Experiments über wirtschaftliche Themen gelernt hast. Die Fragen sind ähnlich wie am Anfang. So können wir sehen, ob sich dein Wissen verändert hat.",
    group: "Testing", // <---- hinzugefügt!
    screens: [
        { component: PosttestScreen1,
            canContinueDefault: false,  // Nur hier!
        }        // UltimatumScreen2Config,
        // Add more screens/configs here if needed
    ]
};


